//影厅管理
// 2.1.3.1.获取TMS中所有的影厅信息（tms.getAllAuditorium）
// const invokeRemoteMethod = '/system/session';
const invokeRemoteMethod = '/v1/invoke/invokeRemoteMethod';
const post5cad9f63e4f94 = '/v1/5cad9f63e4f94'; //注册
const post5b5bdc44796e8 = '/v1/5b5bdc44796e8'; //获取验证码
const post5c78dbfd977cf = '/v1/5c78dbfd977cf'; //手机号密码登录
const post5c78dca45ebc1 = '/v1/5c78dca45ebc1'; //手机号验证码登录
const post5caeeba9866aa = '/v1/5caeeba9866aa'; //用验证码重置密码
const post62fb8dc3857d1 = '/v1/62fb8dc3857d1'; //获取客服信息
const post5d63befcb25d9 = '/v1/5d63befcb25d9'; //获取指定文章单页信息
const post62bd01fd4eb3d = '/v1/62bd01fd4eb3d'; //个人中心用户信息
const post62bd647d75500 = '/v1/62bd647d75500'; //论坛-动态详情
const post62bbebb06f8ac	= '/v1/62bbebb06f8ac'; //文章分类
const post62bd16bb38225 = '/v1/62bd16bb38225'; //论坛发布
const post5d5fa8984f0c2 = '/v1/5d5fa8984f0c2'; //图片上传
const post62bd4473dfb8c = '/v1/62bd4473dfb8c'; //今日折扣信息发布
const post62bd1e2b8f61d = '/v1/62bd1e2b8f61d'; //置顶提交页面接口
const get5d88ab98cbb1f = '/v1/5d88ab98cbb1f'; //统一获取订单详情
const post62bd44edb21ee = '/v1/62bd44edb21ee'; //本地生活信息发布
const post62bd4e45ea8ad = '/v1/62bd4e45ea8ad'; //获取标签数组
const post62bd1b20ae91e = '/v1/62bd1b20ae91e'; //入驻商家发布
const post62bd4550a0ec2 = '/v1/62bd4550a0ec2'; //二手交易发布
const post62bd48203bf91 = '/v1/62bd48203bf91';//二手车信息发布
const post62bd4f3c2df91 = '/v1/62bd4f3c2df91'; //招聘/租房 获取区域列表
const post62bd4939210ad = '/v1/62bd4939210ad'; //招聘信息发布
const post62cd37d3b1672 = '/v1/62cd37d3b1672'; //房屋户型接口
const post62bd462865971 = '/v1/62bd462865971'; //租房信息发布
const post62bd4aaf99a08 = '/v1/62bd4aaf99a08'; //宠物信息发布
const post62bd668415e8a = '/v1/62bd668415e8a'; //获取认证状态
const post62df8db88772e = '/v1/62df8db88772e'; //获取认证信息
const post5d6baaec27b0d = '/v1/5d6baaec27b0d'; //提交实名认证
const post62bcfb34c52e7 = '/v1/62bcfb34c52e7'; //主页列表及发布中列表
const post5cb54af125f1c = '/v1/5cb54af125f1c'; //个人资料修改
const post5f6db4db8abcf = '/v1/5f6db4db8abcf'; //校验验证码
const post5f6c915d69d1f = '/v1/5f6c915d69d1f'; //修改手机号
const post611084af40d41 = '/v1/611084af40d41'; //注销原因接口
const post61035f64462d4 = '/v1/61035f64462d4'; //注销用户提交
const post62cd38d616320 = '/v1/62cd38d616320'; //获取注销状态
const post62bd75ab14110 = '/v1/62bd75ab14110'; //粉丝/关注是否显示
const post62bd05e0f4019 = '/v1/62bd05e0f4019'; //关注/粉丝列表
const post62bd55cd493f2 = '/v1/62bd55cd493f2'; //关注/取消关注接口
const post62bd75dfba20f = '/v1/62bd75dfba20f'; //获取黑名单列表
const post62bd762825c98 = '/v1/62bd762825c98'; //移除黑名单
const post62bc0e0204f3a = '/v1/62bc0e0204f3a'; //入驻商家详情
const post62df82ebe9864 = '/v1/62df82ebe9864'; //文章删除接口
const post62bc1215cd5e7 = '/v1/62bc1215cd5e7'; //今日折扣详情
const post62bc13e029178 = '/v1/62bc13e029178'; //本地生活详情
const post62bc1558294ee = '/v1/62bc1558294ee'; //二手交易详情
const post62bc1daa685f9 = '/v1/62bc1daa685f9'; //租房详情
const post62bc25bc644b0 = '/v1/62bc25bc644b0'; //二手车详情
const post62bc288dc6e04 = '/v1/62bc288dc6e04'; //招聘详情
const post62bc2a3ad9511 = '/v1/62bc2a3ad9511'; //宠物详情
const post62e8794e8e25b = '/v1/62e8794e8e25b'; //一键置顶
const post62bd5fdd578f6 = '/v1/62bd5fdd578f6'; //历史记录
const post62bd774db5686 = '/v1/62bd774db5686'; //联系我们
const post62bd5f88b1acb = '/v1/62bd5f88b1acb'; //收藏列表
const post62bd60e3ad36e = '/v1/62bd60e3ad36e'; //历史记录批量删除
const post5d63ba953ee01 = '/v1/5d63ba953ee01'; //获取投诉建议反馈类型
const post5cc3f28296cf0 = '/v1/5cc3f28296cf0'; //提交意见反馈
const post5cb97ad30ea88 = '/v1/5cb97ad30ea88'; //会员投诉建议 意见反馈
const post62bd520a69f54 = '/v1/62bd520a69f54'; //收藏类型消息列表
const post62bd550b6d8df = '/v1/62bd550b6d8df'; //获取关注类列表
const post62bd5342a3a8e = '/v1/62bd5342a3a8e'; //获取评论类消息列表
const post618a38c0ca95f = '/v1/618a38c0ca95f'; //公告列表
const post632bca030eb94 = '/v1/632bca030eb94'; //pc扫码支付
const post632d16b27b0e6 = '/v1/632d16b27b0e6'; //pc支付宝支付
const post5d7757d28d076 = '/v1/5d7757d28d076'; //微信登录绑定手机号
const post632e6b2c9d28b = '/v1/632e6b2c9d28b'; //获取PC扫码登录信息
const post63687667584ca = '/v1/63687667584ca'; //保存环信聊天记录及生成聊天列表
const post63687a04ce172 = '/v1/63687a04ce172'; //获取会话列表
const post63687c01c5bfe	= '/v1/63687c01c5bfe'; //获取聊天记录
const post63687d1a5bfb4 = '/v1/63687d1a5bfb4'; //批量删除会话列表

let apiConfig = {
    invokeRemoteMethod,
    post5cad9f63e4f94,
    post5b5bdc44796e8,
    post5c78dbfd977cf,
    post5c78dca45ebc1,
    post5caeeba9866aa,
    post62fb8dc3857d1,
    post5d63befcb25d9,
    post62bd01fd4eb3d,
    post62bd647d75500,
    post62bbebb06f8ac,
    post62bd16bb38225,
    post5d5fa8984f0c2,
    post62bd4473dfb8c,
    post62bd1e2b8f61d,
    get5d88ab98cbb1f,
    post62bd44edb21ee,
    post62bd4e45ea8ad,
    post62bd1b20ae91e,
    post62bd4550a0ec2,
    post62bd48203bf91,
    post62bd4f3c2df91,
    post62bd4939210ad,
    post62cd37d3b1672,
    post62bd462865971,
    post62bd4aaf99a08,
    post62bd668415e8a,
    post62df8db88772e,
    post5d6baaec27b0d,
    post62bcfb34c52e7,
    post5cb54af125f1c,
    post5f6db4db8abcf,
    post5f6c915d69d1f,
    post611084af40d41,
    post61035f64462d4,
    post62cd38d616320,
    post62bd75ab14110,
    post62bd05e0f4019,
    post62bd55cd493f2,
    post62bd75dfba20f,
    post62bd762825c98,
    post62bc0e0204f3a,
    post62df82ebe9864,
    post62bc1215cd5e7,
    post62bc13e029178,
    post62bc1558294ee,
    post62bc1daa685f9,
    post62bc25bc644b0,
    post62bc288dc6e04,
    post62bc2a3ad9511,
    post62e8794e8e25b,
    post62bd5fdd578f6,
    post62bd774db5686,
    post62bd5f88b1acb,
    post62bd60e3ad36e,
    post5d63ba953ee01,
    post5cc3f28296cf0,
    post5cb97ad30ea88,
    post62bd520a69f54,
    post62bd550b6d8df,
    post62bd5342a3a8e,
    post618a38c0ca95f,
    post632bca030eb94,
    post632d16b27b0e6,
    post5d7757d28d076,
    post632e6b2c9d28b
}
export default apiConfig;



// WEBPACK FOOTER //
// ./src/api-config.js